<template>
  <div class="bjzc-tabs">
    <ul class="uk-tab-right uk-visible@m" uk-tab>
      <li v-for="item in options" :key="item.value" :class="{ 'uk-active': value === item.value }">
        <a @click="handleChange(item)">
          <img v-if="item.imagePath" class="icon" :src="require(`@/assets/images/${item.imagePath}`)" alt="" />
          <span>{{ item.name }}</span>
        </a>
      </li>
    </ul>
    <div class="button-tab uk-hidden@m">
      <div
        v-for="item in options"
        :key="item.value"
        :class="{ 'uk-active': value === item.value }"
        class="button-tab-item"
        @click="handleChange(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleChange(item) {
      this.$emit('input', item.value)
      this.$emit('change', item.value)
    }
  }
}
</script>

<style lang="scss">
.bjzc-tabs {
  margin-bottom: 1rem;
  .uk-tab::before {
    display: none;
  }
  .uk-tab > * > a {
    box-sizing: border-box;
    min-width: 10rem;
    height: 2.5rem;
    color: $text-normal;
    border-left: 3px solid transparent;

    display: flex;
    align-items: center;

    &:hover {
      color: $color-primary;
    }
  }
  .uk-tab > .uk-active > a {
    color: $color-primary;
    border-color: $color-primary;
    background-color: #f0f0f0;
  }

  .uk-tab .icon {
    height: 1.13rem;
    margin-right: 0.5rem;
  }

  .button-tab {
    margin-top: -0.63rem;
    display: flex;
    flex-wrap: wrap;
    .button-tab-item {
      padding: 0.25rem 0.5rem;
      border-radius: 0.5rem;
      color: #92929e;
      font-size: 0.88rem;
      line-height: 1.25rem;
      margin-right: 0.6rem;

      &.uk-active {
        color: #fff;
        background-color: $color-primary;
      }
    }
  }
}
</style>
